import styled from "styled-components";

export const CMWizardModalStep = styled.div((props) => ({
  padding: props.theme.spacers["5"],
  "& h2": {
    textAlign: "center",
    margin: props.theme.spacers["5"],
    marginTop: 0,
    paddingBottom: "1rem",
    fontFamily: props.theme.fontFamilies.workSans,
    borderBottom: `solid 1px ${props.theme.palette.primary.main}`,
    fontWeight: "normal",
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    width: "98% !important",
    paddingLeft: "3%",
    paddingRight: 0,
    paddingTop: 0,
    "& h2": {
      textAlign: "left",
      paddingTop: 30,
      paddingBottom: "0.5rem",
    },
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    width: "98% !important",
    paddingLeft: "3%",
    paddingRight: 0,
    paddingTop: 0,
    "& h2": {
      textAlign: "left",
      paddingTop: 30,
      paddingBottom: "0.5rem",
    },
  },
  [`@media (min-width: 500px) and (max-width:600px)`]: {
    maxWidth: 575,
    paddingLeft: 21,
    paddingRight: 0,
    paddingTop: 0,
    "& h2": {
      textAlign: "left",
      paddingTop: 20,
      paddingBottom: "0.5rem",
    },
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    maxWidth: 480,
    //paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    "& h2": {
      textAlign: "left",
      paddingTop: 25,
      paddingBottom: "0.5rem",
    },
  },
  [`@media ${props.theme.breakpoints.xss}`]: {
    maxWidth: 400,
  },
}));
